import React from 'react';
import { useTranslation } from 'react-i18next';
import type { TransportWarehouseDocument } from '../../../types/transport';
import './TransportDocumentLinks.css';

/** Operational metadata only: no prices or stock mutations. */
export default function TransportDocumentLinks({ documents, orderId, onlyPZ = false }: {
  documents?: TransportWarehouseDocument[];
  orderId?: string;
  onlyPZ?: boolean;
}) {
  const { t } = useTranslation('transport');
  if (!documents) return null;
  const visible = documents.filter(document => document.kind === 'pz' || !orderId || document.orderId === orderId);
  return (
    <div className="transport-document-links" role="group" aria-label={t('documents.title')}>
      {(onlyPZ ? ['pz'] as const : ['pz', 'wz'] as const).map(kind => {
        const group = visible.filter(document => document.kind === kind);
        return (
          <div className="transport-document-links__group" key={kind}>
            <span className="transport-document-links__kind">{kind.toUpperCase()}</span>
            <div className="transport-document-links__items">
              {group.length === 0 ? <span className="transport-document-links__empty">{t('documents.none')}</span> : group.map(document => (
                <a
                  key={document.id}
                  className={`transport-document-links__link transport-document-links__link--${document.status.toLowerCase()}`}
                  href={`/app/${document.kind}/${encodeURIComponent(document.id)}`}
                  title={document.orderNumber ? `${t('documents.order')}: ${document.orderNumber}` : undefined}
                >
                  <span className="transport-document-links__number">{document.number}</span>
                  <span className="transport-document-links__status">
                    {t(`documents.status.${document.status}`, { defaultValue: t('documents.unknownStatus') })}
                  </span>
                </a>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
